import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const highlighterDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),

    /**
     * Gets innerHTML
     * @returns {Promise<string>}
     */
    html: async () => {
      return (await base.getNative()).innerHTML;
    },

    /**
     * Gets the driver element
     * @returns {Promise<any>}
     */
    getElement: () => {
      return base.getNative();
    },
  };
};
